import {
  WISHLIST_ACTIONS,
  type DisplayNotificationAction,
  type OpenModalAction,
  type WishlistAction,
  type WishlistNotificationData,
} from './Wishlists.actions';

// state definition
export interface WishlistsReducerState {
  notification: WishlistNotificationData | null;
  modalToOpen: string | null;
}

const initialState = {
  notification: null,
  modalToOpen: null,
};

// reducer
const events = {
  [WISHLIST_ACTIONS.DISPLAY_NOTIFICATION]: (
    state: WishlistsReducerState,
    action: Omit<DisplayNotificationAction, 'type'>,
  ) => ({
    ...state,
    notification: action,
  }),
  [WISHLIST_ACTIONS.HIDE_NOTIFICATION]: (state: WishlistsReducerState) => ({
    ...state,
    notification: null,
  }),
  [WISHLIST_ACTIONS.OPEN_MODAL]: (
    state: WishlistsReducerState,
    { modalId }: Omit<OpenModalAction, 'type'>,
  ) => ({
    ...state,
    modalToOpen: modalId,
  }),
  [WISHLIST_ACTIONS.CLOSE_MODAL]: (state: WishlistsReducerState) => ({
    ...state,
    modalToOpen: null,
  }),
};

export const wishlistReducer = (
  state: WishlistsReducerState = {
    ...initialState,
  },
  { type, ...action }: WishlistAction,
): WishlistsReducerState => {
  if (!(type in events)) return state;
  return events[type](state, { ...action } as any);
};
